import React, { memo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const AdminRoute = memo(function AdminRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);
  const location = useLocation();

  useEffect(() => {
    if (session.status === "unauthorized") {
      navigate("/admin/signin");
      return;
    }
    if (
      session.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "admin" &&
      location.pathname === "/admin"
    ) {
      navigate("/admin/dashboard");
      return;
    } else if (
      session.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "user"
    ) {
      navigate("/");
      return;
    } else if (
      session?.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "donor"
    ) {
      navigate("/donor/donation");
    }
  }, [session.status, navigate, session?.user?.role?.toLowerCase()]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "authorized" &&
    session?.user?.role?.toLowerCase() === "admin"
    ? children
    : null;
});

export default AdminRoute;
